/**
 * 印刷区分
 */
export const ReportConst = 
{
  /**
   * 出庫一覧表
   */
  SYUKKO_ICHIRAN: 1,
  /**
   * 手合票
   */
  TEAWASE: 2,
  /**
   * 落札結果一覧表
   */
  RAKUSATSU_ICHIRAN: 3,
} as const;
export type  ReportType = typeof ReportConst[keyof typeof ReportConst];